export default __webpack_public_path__ + "content/67c6622ebf03ed5cafa740c9dcfba4b8.woff";